import React, { Component } from "react";
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import { connect } from "react-redux";
import { compose } from "redux";
import Modal from '@material-ui/core/Modal';
import ClearIcon from "@material-ui/icons/Clear";
import Fab from '@material-ui/core/Fab';
import TextField from '@material-ui/core/TextField';
import RadioButtonGroup from '@material-ui/core/RadioGroup';
import RadioButton from '@material-ui/core/Radio';
import FormLabel from '@material-ui/core/FormLabel';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';

import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import IconButton from '@material-ui/core/IconButton';
import red from '@material-ui/core/colors/red';
// import MoreVertIcon from '@material-ui/icons/MoreVert';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import Calendar from "./Calendar";
import TeamMember from "./TeamMember";
import Bookings from "./Booking";
import Program from "./Program";
// import Table from '@material-ui/core/Table';
// import TableBody from '@material-ui/core/TableBody';
// import TableCell from '@material-ui/core/TableCell';
// import TableHead from '@material-ui/core/TableHead';
// import TableRow from '@material-ui/core/TableRow';
import { fetchTeam, fetchTeamMember, updateTeam } from "../actions/TeamAction";
import { fetchPrograms } from "../actions/ProgramAction"
import NewCoachRequest from "./NewCoachRequest";
import { ATTACHMENT_END_POINT } from "../helpers/constants";
import notfound from '../assets/notfound.png';
import Link from '@material-ui/core/Link';
const { innerWidth } = window;

// import Program from "./Program";

// const CustomTableCell = withStyles(theme => ({
//     head: {
//         // backgroundColor: "#6128be",
//         // color: theme.palette.common.white,
//         color: "#2926ac",
//         fontWeight:"bold",
//         fontSize: 13
//     },
//     body: {
//         fontSize: 14,
//     },
// }))(TableCell);

function getModalStyle() {
    return {
        top: `50%`,
        left: `50%`,
        transform: `translate(-50%, -50%)`,
    };
}

const styles = theme => ({
    card: {
        // wordBreak: "break-all"
    },
    media: {
        // ⚠️ object-fit is not supported by IE 11.
        objectFit: 'cover',
        height: 0,
        paddingTop: '56.25%', // 16:9
    },
    root: {
        flexGrow: 1,
    },

    image: {
        width: '100%',
        height: '100%',
    },
    img: {
        margin: 'auto',
        display: 'block',
        maxWidth: '100%',
        maxHeight: '100%',
    },
    grow: {
        flexGrow: 1,
    },
    fontOptions: {
        lineHeight: 1.8,
    },
    centerText: {
        textAlign: 'center'
    },
    headerTextColor: {
        color: '#1E1759',
        fontWeight: 'bold',
        lineHeight: 1.8,
    },
    paragraphTextColor: {
        color: '#888',
        fontWeight: 300,
        fontSize: 15
    },
    gradientButton: {
        // background: 'linear-gradient(to right, #2926ac 0%, #6128be 100%)'
        // background: '#6128be'
        // background: '#86C42B'
        background: 'green',
        '&:focus': {
            background: 'green'
        },
        '&:hover': {
            background: '#27ad67'
        },
        '&:active': {
            background: '#27ad67'
        }
    },
    buttons: {
        background: 'green',
        color: 'white'
    },
    papers: {
        position: 'absolute',
        width: innerWidth >= 480 ? theme.spacing.unit * 100 : (innerWidth - (theme.spacing.unit * 2)),
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: innerWidth >= 480 ? theme.spacing.unit * 4 : theme.spacing.unit * 2,
        outline: 'none',
        borderRadius: 5

    },
    margin: {
        margin: theme.spacing.unit,
    },
    closeButtonFab: {
        float: 'right',
        marginRight: innerWidth >= 480 ? '-54px' : '-34px',
        marginTop: innerWidth >= 480 ? '-54px' : '-44px'
    },

    backGrd: {
        background: 'linear-gradient(to right, #2926ac 0%, #6128be 100%)',
        height: 20
    },
    cancelbutton: {
        margin: theme.spacing.unit,
    },
    button1: {
        background: 'linear-gradient(to right, #2926ac 0%, #6128be 100%)',
        color: 'white'
    },
    textField: {
        // width: 270,
        marginTop: -8,
        marginLeft: 8
    },
    input: {
        display: "none",
        height: 43
    },
    inputStyle: {
        padding: '12px 2px',
        fontSize: 14,
        color: 'rgba(0, 0, 0, 0.87)',
    },
    labelRoot: {
        fontSize: '1.3rem',
    },

    // card: {
    //     maxWidth: 400,
    // },
    // media: {
    //     height: 0,
    //     paddingTop: '56.25%', // 16:9
    // },
    actions: {
        display: 'flex',
    },
    expand: {
        transform: 'rotate(0deg)',
        marginLeft: 'auto',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        }),
    },
    expandOpen: {
        transform: 'rotate(180deg)',
    },
    avatar: {
        backgroundColor: red[500],
    },
    tabsRoot: {
        borderBottom: '1px solid #e8e8e8',
    },
    tabsIndicator: {
        backgroundColor: '#1890ff',
    },
    tabRoot: {
        textTransform: 'initial',
        minWidth: 72,
        fontWeight: theme.typography.fontWeightRegular,
        marginRight: theme.spacing.unit * 4,
        '&:hover': {
            color: '#40a9ff',
            opacity: 1,
        },
        '&$tabSelected': {
            color: '#1890ff',
            fontWeight: theme.typography.fontWeightMedium,
        },
        '&:focus': {
            color: '#40a9ff',
        },
    },
    tabSelected: {},
    typography: {
        padding: theme.spacing.unit * 3,
    },
    table: {
        minWidth: 700,
        // marginTop: 50
    },
    // row: {
    //     '&:nth-of-type(odd)': {
    //         backgroundColor: theme.palette.background.default,
    //     },
    // },
});


function TabContainer(props) {
    return (
        <Typography component="div" style={{ padding: 8 * 3 }}>
            {props.children}
        </Typography>
    );
}


class Team extends Component {
    constructor() {
        super();
        this.state = {
            open: false,
            interest_on_stem_learning: null,
            team_name: '',
            team_url: '',
            interest_on_stem_learning_error: false,
            team_name_error: false,
            city: " ",
            selectedTab: 0,
            description: "",
            myTeam: {},
            team_image: null,
            selected_team_image_name: "",
            id: null
        };
    }
    componentDidMount() {
        this.props.dispatch(fetchTeam());
        this.props.dispatch(fetchTeamMember());
        this.props.dispatch(fetchPrograms())
        // alert(this.props.location.state)
        if (this.props.location.state !== undefined) {
            const { selectedTab } = this.props.location.state;
            // alert(selectedTab);
            this.setState({ selectedTab: selectedTab !== undefined ? selectedTab : 0 });
        }

    }
    handleOpen = () => {
        this.setState({
            open: true,
            interest_on_stem_learning: this.props.myTeam.length > 0 ? this.props.myTeam[0].interested_in_stem : null,
            team_name: this.props.myTeam.length > 0 ? this.props.myTeam[0].team_name : '',
            team_url: this.props.myTeam.length > 0 ? this.props.myTeam[0].website_url : '',
            city: this.props.myTeam.length > 0 ? this.props.myTeam[0].city : " ",
            description: this.props.myTeam.length > 0 ? this.props.myTeam[0].description : " ",
            id: this.props.myTeam.length > 0 ? this.props.myTeam[0].id : null,
            selected_team_image_name: this.props.myTeam.length > 0 ? this.props.myTeam[0].attachments.length > 0 ? this.props.myTeam[0].attachments[0].file_name : "" : ""
        });

    };
    buttonchange = () => {
        let isError = false;
        if (this.state.interest_on_stem_learning === null) {
            this.setState({ interest_on_stem_learning_error: true })
            isError = true
        }
        if (this.state.team_name === '') {
            this.setState({ team_name_error: true })
            isError = true
        }

        if (this.state.team_url !== "" && this.state.team_url !== null) {
            if (!this.validateUrl(this.state.team_url)) {
                this.setState({ team_url_invalid_error: true })
                isError = true
            }
        }

        if (isError === false) {
            this.props.dispatch(updateTeam(this, this.state))
            this.setState({
                open: false,
                interest_on_stem_learning: null,
                team_name: '',
                team_url: '',
                interest_on_stem_learning_error: false,
                team_name_error: false,
                city: " ",
                description: "",
                team_image: null,
                selected_team_image_name: "",
                id: null
            });
        }
    }
    handleChangeApproval = (event) => {
        this.setState({ interest_on_stem_learning: event.target.value, interest_on_stem_learning_error: false })
    };



    handleClose = () => {
        this.setState({
            open: false,
            interest_on_stem_learning: null,
            team_name: '',
            team_url: '',
            interest_on_stem_learning_error: false,
            team_name_error: false,
            city: " ",
            description: "",
            team_image: null,
            selected_team_image_name: "",
            id: null
        });
    };
    validateEmail(email) {
        var re = /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }
    validateUrl(url) {
        var re = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\\-\\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/
        return re.test(url);
    }

    teamImage = ({ target }) => {
        this.setState({ team_image: target.files[0], selected_team_image_name: target.files[0].name });
    };

    handleChange = (event, selectedTab) => {
        this.setState({ selectedTab });
    };
    render() {
        const { classes, defaultRole } = this.props;
        // console.log(JSON.stringify(this.props.myTeam))
        return (
            <Grid container spacing={24}>
                <Grid container spacing={8}>
                    {defaultRole === "THUNDERBOT" &&
                        <Grid item xs={12}>
                            <NewCoachRequest />
                        </Grid>
                    }
                    {defaultRole === "COACH" &&
                        <Grid item xs={12}>
                            <Grid container spacing={16}>
                                <Grid item xs={12} sm={3}>
                                    <Card className={classes.card}>
                                        <CardHeader
                                            action={
                                                <IconButton onClick={this.handleOpen}>
                                                    <FontAwesomeIcon icon="pencil-alt" style={{ fontSize: 15 }} />
                                                </IconButton>
                                            }
                                            title={this.props.myTeam.length > 0 ? this.props.myTeam[0].team_name : null}
                                            subheader=""
                                        />
                                        {/* <img src={this.props.myTeam.length > 0 ? this.props.myTeam[0].attachments.length > 0 ? `${ATTACHMENT_END_POINT}${this.props.myTeam[0].attachments[0].file_name}` : notfound  : notfound } className={classes.img} alt="Logo" /> */}

                                        <CardMedia
                                            className={classes.media}
                                            image={this.props.myTeam.length > 0 ? this.props.myTeam[0].attachments.length > 0 ? `${ATTACHMENT_END_POINT}${this.props.myTeam[0].attachments[0].file_name}` : notfound : notfound}
                                        />
                                        <CardContent>
                                            {/* <Typography gutterBottom style={{ marginBottom: 15 }}><FontAwesomeIcon icon="phone" style={{ fontSize: 12, marginRight: 5 }} />916-264-2920</Typography>
                                        <Typography component="p" gutterBottom style={{ marginBottom: 15 }}>
                                            <FontAwesomeIcon icon="envelope" style={{ fontSize: 12, marginRight: 5 }} /> library@ca.com
                                        </Typography> */}
                                            <Typography component="p" gutterBottom style={{ marginBottom: 15 }}>
                                                <FontAwesomeIcon icon="address-book" style={{ fontSize: 12, marginRight: 5 }} />
                                                {this.props.myTeam.length > 0 ? this.props.myTeam[0].city : ""}
                                            </Typography>
                                            <Typography component="p" gutterBottom style={{ marginBottom: 15 }}>
                                                <FontAwesomeIcon icon="link" style={{ fontSize: 12, marginRight: 5 }} />
                                                {this.props.myTeam.length > 0 &&
                                                    <Link href={this.props.myTeam[0].website_url} className={classes.link}> {this.props.myTeam[0].website_url}</Link>
                                                }
                                            </Typography>
                                            <Typography component="p" gutterBottom style={{ textAlign: "justify" }}>
                                                {/* <FontAwesomeIcon icon="link" style={{ fontSize: 12, marginRight: 5 }} />  */}
                                                {this.props.myTeam.length > 0 ? this.props.myTeam[0].description : ""}
                                            </Typography>
                                        </CardContent>
                                        <CardActions className={classes.actions} disableActionSpacing>

                                        </CardActions>
                                    </Card>
                                </Grid>
                                <Grid item xs={12} sm={9} container>
                                    <Grid item xs={12} >
                                        <Tabs
                                            value={this.state.selectedTab}
                                            onChange={this.handleChange}
                                            classes={{ root: classes.tabsRoot, indicator: classes.tabsIndicator }}
                                        >
                                            <Tab
                                                disableRipple
                                                classes={{ root: classes.tabRoot, selected: classes.tabSelected }}
                                                icon={<FontAwesomeIcon icon="calendar" />}
                                            />
                                            <Tab
                                                disableRipple
                                                classes={{ root: classes.tabRoot, selected: classes.tabSelected }}
                                                label="Team Member"
                                            // icon={<FontAwesomeIcon icon="building"/>}
                                            />
                                            <Tab
                                                disableRipple
                                                classes={{ root: classes.tabRoot, selected: classes.tabSelected }}
                                                label="Program"
                                            // icon={<FontAwesomeIcon icon="building"/>}
                                            />
                                        </Tabs>
                                        {this.state.selectedTab === 0 && <TabContainer> <Bookings /> <Calendar /></TabContainer>}

                                        {this.state.selectedTab === 1 &&
                                            <TabContainer>
                                                <TeamMember team_id={this.props.user.parent_ref} />

                                            </TabContainer>
                                        }
                                        {this.state.selectedTab === 2 && <TabContainer> <Program /> </TabContainer>}

                                    </Grid>
                                </Grid>

                            </Grid>
                        </Grid>
                    }
                </Grid>

                <Modal
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    open={this.state.open}
                    onClose={this.handleClose}
                    disableBackdropClick={true}
                >
                    <div style={getModalStyle()} className={classes.papers}>
                        <div className={classes.closeButtonFab}>
                            <Fab size="small" color="secondary" aria-label="Add" className={classes.margin} onClick={this.handleClose}>
                                <ClearIcon />
                            </Fab>
                        </div>
                        <Typography variant="h6" >
                            Edit Team
                        </Typography>
                        <Grid container spacing={8}>
                            <Grid item xs={12} style={{ marginTop: 15 }}>
                                <FormLabel component="legend" required style={{ marginLeft: "10px", fontSize: "15px", color: 'black' }} error={this.state.interest_on_stem_learning_error === true ? true : false}>
                                    Are you a First team interested in learning more about STEM learning exchange program ?
                                </FormLabel>
                                <RadioButtonGroup defaultValue={this.state.interest_on_stem_learning} onChange={this.handleChangeApproval} row style={{ marginLeft: "10px" }}>
                                    <FormControlLabel value={this.state.interest_on_stem_learning === true ? true : "Yes"} control={<RadioButton />} label="Yes" />
                                    <FormControlLabel value={this.state.interest_on_stem_learning === false ? false : "No"} control={<RadioButton />} label="No" />
                                </RadioButtonGroup>
                                <FormHelperText style={{ marginLeft: 10 }} error> {this.state.interest_on_stem_learning_error === true ? "Please select any one option Yes/NO" : false} </FormHelperText>
                            </Grid>
                            <Grid item sm={4} xs={6}>
                                <TextField
                                    label="Team name"
                                    fullWidth
                                    className={classes.textField}
                                    value={this.state.team_name}
                                    margin="normal"
                                    onChange={(event) => this.setState({ team_name: event.target.value.charAt(0).toUpperCase() + event.target.value.slice(1), team_name_error: false })}
                                    error={this.state.team_name_error === true ? true : false}
                                    helperText={this.state.team_name_error === true ? "Please enter team name" : null}
                                    InputProps={{ classes: { input: classes.inputStyle } }}
                                    InputLabelProps={{
                                        shrink: true,
                                        FormLabelClasses: {
                                            root: classes.labelRoot
                                        }
                                    }}
                                />
                            </Grid>
                            <Grid item sm={4} xs={6}>
                                <TextField
                                    label="City"
                                    fullWidth
                                    className={classes.textField}
                                    margin="normal"
                                    value={this.state.city}
                                    onChange={(event) => this.setState({ city: event.target.value.charAt(0).toUpperCase() + event.target.value.slice(1) })}
                                    InputProps={{ classes: { input: classes.inputStyle } }}
                                    InputLabelProps={{
                                        shrink: true,
                                        FormLabelClasses: {
                                            root: classes.labelRoot
                                        }
                                    }}
                                />
                            </Grid>
                            <Grid item sm={4} xs={12}>
                                <TextField
                                    label="Team website URL"
                                    fullWidth
                                    className={classes.textField}
                                    error={this.state.team_url_invalid_error === true ? true : false}
                                    helperText={this.state.team_url_invalid_error === true ? "Please Enter Valid URL" : null}
                                    value={this.state.team_url}
                                    onChange={(event) => this.setState({ team_url: event.target.value, team_url_invalid_error: false })}
                                    margin="normal"
                                    InputProps={{ classes: { input: classes.inputStyle } }}
                                    InputLabelProps={{
                                        shrink: true,
                                        FormLabelClasses: {
                                            root: classes.labelRoot
                                        }
                                    }}
                                />
                            </Grid>
                            
                            <Grid item xs={12} >
                                <TextField
                                    label="Description"
                                    fullWidth
                                    className={classes.textField}
                                    value={this.state.description}
                                    onChange={(event) => this.setState({ description: event.target.value })}
                                    margin="normal"
                                    multiline
                                    InputProps={{ classes: { input: classes.inputStyle } }}
                                    InputLabelProps={{
                                        shrink: true,
                                        FormLabelClasses: {
                                            root: classes.labelRoot
                                        }
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <input
                                    accept="image/*"
                                    className={classes.input}
                                    id="contained-button-file"
                                    type="file"
                                    onChange={this.teamImage}
                                    
                                />
                                <label htmlFor="contained-button-file">
                                    <Button variant="outlined" component="span" className={classes.gradientButton}>
                                        Upload team image
                                    <CloudUploadIcon className={classes.rightIcon} />
                                    </Button>
                                </label>
                                <Typography>{this.state.selected_team_image_name}</Typography>
                            </Grid>
                            <Grid item xs={12} >
                                <div style={{ textAlign: "center" }}>
                                    <Button variant="contained" color="secondary" size="small" className={classes.cancelbutton} onClick={this.handleClose}>
                                        cancel
                                    </Button>
                                    <Button variant="contained" size="small" className={classes.button1} onClick={this.buttonchange}>
                                        Submit
                                    </Button>
                                </div>
                            </Grid>
                        </Grid>
                    </div>

                </Modal>
            </Grid>
        );
    }
}

Team.propTypes = {
    classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
    return {
        myTeam: state.TeamReducer.myTeam,
        user: state.SessionReducer.user,
        teamMembers: state.TeamReducer.teamMembers,
        defaultRole: state.SessionReducer.defaultRole,
        programs: state.ProgramReducer.programs,
    }
}
export default compose(withStyles(styles), connect(mapStateToProps))(Team);
